const $ = require('jquery');
window.$ = $;

var ES6Promise = require("es6-promise");
ES6Promise.polyfill();
const Vue = require('vue').default;
const axios = require('axios').default;
let cancelTokenSource = axios.CancelToken.source();

import {isValidPhoneNumber} from 'libphonenumber-js'
import DeviceList from './vue/DeviceList'
import Vuelidate from 'vuelidate'
import {email, minLength, required} from 'vuelidate/lib/validators'

Vue.use(Vuelidate);

const phoneNumber = function (value) {
    return isValidPhoneNumber(value, 'NL');
}

window.Vue = Vue;

const vueApp = new Vue({
    el: '#quoteApp',
    validations: {
        quoteForm: {
            Market: {
                required
            },
            Solutions: {
                required,
                minLength: minLength(1)
            },
            Name: {
                required,
                minLength: minLength(2)
            },
            Company: {
                required,
                minLength: minLength(2)
            },
            Email: {
                required,
                email
            },
            Phone: {
                required,
                phoneNumber
            },
            Message: {
                required,
                minLength: minLength(10)
            },
            Referrer: {
                required
            },
            ReferrerOther: {
            },
            remarks: {}
        }
    },
    data: {
        logos: [],
        quoteFormSubmitted: false,
        reference: null,
        loading: false,
        engineer: 'onze binnendienst',
        engineerMail: 'verkoop@top.systems',
        engineerPhone: '0172 - 650 737',
        quoteForm: {
            Market: '',
            Solutions: [],
            Name: '',
            Company: '',
            Email: '',
            Phone: '',
            Message: '',
            Referrer: '',
            ReferrerOther: ''
        },
        fieldTouched: [],
        showInfo: false
    },
    components: {
        DeviceList,
    },
    watch: {
        'quoteForm.Market': function () {
            this.getVariables()
        }
    },
    computed: {
        quoteAlertMarket: function () {
            return 'Onder welke markt typeert u uw bedrijf?';
        },
        quoteAlertSolutions: function () {
            return 'Kies minimaal 1 oplossing';
        },
        quoteAlertName: function () {
            return 'Vul uw naam in';
        },
        quoteAlertCompany: function () {
            return 'Vul uw bedrijfsnaam in';
        },
        quoteAlertEmail: function () {
            return 'Vul een geldig e-mailadres in';
        },
        quoteAlertPhone: function () {
            return 'Vul een geldig telefoonnummer in';
        },
        quoteAlertMessage: function () {
            return 'Vul een geldige omschrijving in';
        },
        quoteAlertReferrer: function () {
            return 'Kies een optie';
        },

        progress: function () {
            let total = 0

            if (this.quoteForm.Market && !this.$v.quoteForm.Market.$invalid) {
                total += 10
            }
            if (this.quoteForm.Solutions && !this.$v.quoteForm.Solutions.$invalid) {
                total += 10
            }
            if (this.quoteForm.Name && !this.$v.quoteForm.Name.$invalid) {
                total += 15
            }
            if (this.quoteForm.Company && !this.$v.quoteForm.Company.$invalid) {
                total += 15
            }
            if (this.quoteForm.Email && !this.$v.quoteForm.Email.$invalid) {
                total += 15
            }
            if (this.quoteForm.Phone && !this.$v.quoteForm.Phone.$invalid) {
                total += 15
            }
            if (this.quoteForm.Message && !this.$v.quoteForm.Message.$invalid) {
                total += 15
            }
            if (this.quoteForm.Referrer && !this.$v.quoteForm.Referrer.$invalid) {
                total += 10
            }
            return Math.min(total, 100);
        }
    },
    methods: {
        invalidOnBlur: function (field) {
            let $field = this.$v.quoteForm[field]
            return this.touched(field) && $field.$model !== '' && $field.$dirty && $field.$invalid
        },
        invalidOnSubmit: function (field) {
            let $field = this.$v.quoteForm[field]
            return this.quoteFormSubmitted && $field.$dirty && $field.$invalid
        },
        touched: function (field) {
            return this.fieldTouched.includes(field);
        },
        touch: function (field) {
            if (!this.touched(field)) {
                this.fieldTouched.push(field)
            }
        },

        checkQuoteForm: function ($event) {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.quoteFormSubmitted = true;

            } else {
                $event.target.submit()
            }
        },

        getVariables: function () {
            let self = this;

            axios.get('/api/getSector/', {
                params: {
                    sector: self.quoteForm.Market
                }
            })
                .then(response => {
                    if (response.data.success) {
                        this.sent = true;
                        this.engineer = response.data.sector.DefaultSpecialistName;
                        this.engineerMail = response.data.sector.DefaultSpecialistMail;
                        this.engineerPhone = response.data.sector.DefaultSpecialistPhone;
                        this.logos = response.data.sector.logos;
                    }
                })
                .catch((error) => {
                }).finally(() => {
            });
        },
    },

    beforeMount() {
        if (this.$el.querySelector('#QuoteForm_QuoteForm')) {
            //this.quoteForm.Market = this.$el.querySelector('[name="Market"]')?.value;
            this.quoteForm.Company = this.$el.querySelector('[name="Company"]')?.value;
            this.quoteForm.Email = this.$el.querySelector('[name="Email"]')?.value;
            this.quoteForm.Phone = this.$el.querySelector('[name="Phone"]')?.value;
            this.quoteForm.Message = this.$el.querySelector('[name="Message"]')?.value;
            this.quoteForm.Referrer = this.$el.querySelector('[name="Referrer"]')?.value;
            this.quoteForm.ReferrerOther = this.$el.querySelector('[name="ReferrerOther"]')?.value;

            let selected = []
            $(this.$el).find('#QuoteForm_QuoteForm_Solutions input[type="checkbox"][checked="checked"]').each(function (index, input) {
                selected.push($(input).prop('value'))
            })

            if (selected.length > 0) {
                this.quoteForm.Solutions = selected
            }
        }

    },

    mounted: function () {
        this.logos = JSON.parse(this.$el.getAttribute('data-logos'));

        if (this.$el.getAttribute('data-reference')) {
            this.reference = this.$el.getAttribute('data-reference');
        }
        if (this.$el.getAttribute('data-sector')) {
            this.quoteForm.Market = this.$el.getAttribute('data-sector');
        }
        if (this.$el.getAttribute('data-solutions')) {
            this.quoteForm.Solutions = JSON.parse(this.$el.getAttribute('data-solutions'));
        }
        if (this.$el.getAttribute('data-engineer')) {
            this.engineer = this.$el.getAttribute('data-engineer');
        }
        if (this.$el.getAttribute('data-engineer-mail')) {
            this.engineerMail = this.$el.getAttribute('data-engineer-mail');
        }
        if (this.$el.getAttribute('data-engineer-phone')) {
            this.engineerPhone = this.$el.getAttribute('data-engineer-phone');
        }
    }

});
